module.exports = __webpack_public_path__ + "front/img/b28.ddd33fbe.jpg";